// 1. Import the 'light' build of the library
import {Light as SyntaxHighlighter} from 'react-syntax-highlighter';
// 2. Import ONLY the specific languages you need
import sql from 'react-syntax-highlighter/dist/esm/languages/hljs/sql';
// 3. Import ONLY the specific style you need
import {docco} from 'react-syntax-highlighter/dist/esm/styles/hljs';
import {Button} from '@mui/material';
import {useState} from 'react';

// 4. You must register the languages before using them
SyntaxHighlighter.registerLanguage('sql', sql);

// Now you can use the component
const SQlFormatter = ({sqlQuery}: {sqlQuery: string}) => {
	const [copyStatus, setCopyStatus] = useState('Copy');

	const handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(sqlQuery);
			setCopyStatus('Copied!');
			setTimeout(() => setCopyStatus('Copy'), 2000); // Reset after 2 seconds
		} catch (err) {
			setCopyStatus('Failed!');
			console.error('Failed to copy text: ', err);
		}
	};
	return (
		<div style={{position: 'relative', height: 'auto', width: '100%'}}>
			{/* 2. The button is positioned absolutely inside the parent */}
			<Button
				variant='contained'
				onClick={handleCopy}
				sx={{
					position: 'absolute',
					top: 8,
					right: 8,
					zIndex: 1, // Ensure button is on top
					textTransform: 'none',
				}}
			>
				{copyStatus}
			</Button>
			<SyntaxHighlighter
				language='sql'
				style={docco}
				wrapLongLines={true}
				customStyle={{
					margin: 0,
					borderRadius: '8px',
					padding: '1.5rem',
					paddingTop: '3rem', // Add extra padding at the top for the button
					wordWrap: 'break-word',
				}}
			>
				{sqlQuery}
			</SyntaxHighlighter>
		</div>
	);
};

export default SQlFormatter;
